var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tile",
    { attrs: { link: "egrulz" } },
    [
      _c(
        "tile-title",
        { attrs: { slot: "tileHeader", icon: "clock-o" }, slot: "tileHeader" },
        [_vm._v("Записи в " + _vm._s(_vm.organ))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "records",
          attrs: { slot: "tileContent" },
          slot: "tileContent",
        },
        [
          _vm.records && _vm.records.length > 0
            ? _c("egrul-records-table", {
                attrs: { records: _vm.recordsForTable },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("modal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isModal,
                expression: "isModal",
              },
            ],
            attrs: {
              records: _vm.records,
              title: _vm.title,
              companyName: _vm.companyName,
              organ: _vm.organ,
            },
            on: { "throw-html": _vm.getHtml, "close-modal": _vm.hideModal },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "records-footer",
          attrs: { slot: "tileFooter" },
          slot: "tileFooter",
        },
        [
          _c(
            "tile-button",
            {
              nativeOn: {
                click: function ($event) {
                  return _vm.showModal.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n            Все записи " +
                  _vm._s(_vm.organ) +
                  " (" +
                  _vm._s(_vm.records.length) +
                  ") и подробности\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c("tilePrintPdf", {
            attrs: {
              html: _vm.htmlForPrint,
              filename: "EGRUL",
              title: _vm.title,
              printStyle: _vm.printStyle,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }